
'format es6';

import gsap from 'greensock';
import $ from 'jquery';
import Promise from 'Promise';
import Scroll from '../Scroll';
import ns from 'ns';
import Store from 'store';

import { factory as sectionFactory } from './Section';
import { factory as familyFactory } from './Family';
import { factory as pubFactory } from './Pub';
require('../../views-compiled/domain.result');


const EASING = gsap.Expo;
const REQUESTED_FAMILY_RESULT_KEY = 'requested_family_result';

function DomainResult() {

	this.templateName = 'domain.result.htm';

	let familiesCta;
	let detailsContainer;

	let result;
	let hidePubs;
	this.setResult = (vals) => {
		result = vals;
	};

	this.setPubSettings = (h) => {
		hidePubs = h;
	};

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	this.init = () => {
		return Promise.resolve().then(() => {
			const res = result;

			// Get new array of families sorted by score percentage
			res.families = res.families.map(fam => {
				const newFam = Object.assign({}, fam);
				newFam.prc = Math.ceil(newFam.ratio * 100);

				return newFam;
			}).sort((fam1, fam2) => fam2.prc - fam1.prc);

			return res;
		});
	};

	let currentDisplayedFamily;
	const renderDomainDetails = (familyId) => {
		const onOut = (currentDisplayedFamily && currentDisplayedFamily.animateOut()) || Promise.resolve();

		onOut.then(() => {
			currentDisplayedFamily = familyFactory();
			const prc = result.families.find(f => f.id === familyId).prc;
			const onDataSet = currentDisplayedFamily.setData(familyId, result.domain.nom, prc);

			onDataSet.then(() => {
				const onReady = currentDisplayedFamily.render(detailsContainer);
				onReady.then(() => {
					familiesCta.on('click.cursus', familyCtaClick);
					currentDisplayedFamily.animateIn();

					if (ns.isMobile()) {
						Scroll.moveToContent(detailsContainer, $('#header').height());
					}

					currentDisplayedFamily.onNext(() => {
						this.animateOut().then(() => {
							this.next && this.next();
						});
					});
				});
			});
		});
	};

	const familyCtaClick = (e) => {
		const clicked = $(e.currentTarget);
		const familyId = String(clicked.data('family-cta'));
		familiesCta.off('click.cursus');
		familiesCta.removeClass('current-item');
		clicked.addClass('current-item');
		renderDomainDetails(familyId);
	};

	this.activateFamiliesCta = () => {
		familiesCta.on('click.cursus', familyCtaClick);
		let cta = familiesCta.eq(0);

		// If we requested a family in particular (example : coming from the menu)
		if (Store.get(REQUESTED_FAMILY_RESULT_KEY) != null) {
			cta = familiesCta.filter(`[data-family-cta="${Store.get(REQUESTED_FAMILY_RESULT_KEY)}"]`);
		}

		cta.trigger('click');
		Store.remove(REQUESTED_FAMILY_RESULT_KEY);
	};

	this.activate = () => {
		//dataLayer.push({
		//	'event': 'customEvent',
		//	'eventCategory': 'test cursus',
		//	'eventAction': 'domaine',
		//	'eventLabel': data.nom
		//});

		detailsContainer = $('[data-family-desc]', this.sectionNode);
		familiesCta = $('[data-family-cta]', this.sectionNode);

		// Don't show Pubs on mobile
		if (ns.isMobile()) {
			this.setPubSettings(true);
		}

		const progressBars = familiesCta.find('.progress');
		progressBars.each((i, el) => {
			const $el = $(el);
			gsap.TweenMax.to($el, 1, { width: $el.data('width'), delay: 0.5 * i });
		});

		// Hide pubs is set to true if we already visited this category/family
		if (hidePubs) {
			$('[data-load-title]').css('opacity', 1);
			this.activateFamiliesCta();
		} else {
			const pub = pubFactory();
			pub.setData();
			pub.render(detailsContainer).then(() => {
				pub.animateIn();
				pub.onNext(() => {
					this.activateFamiliesCta();
				});
			});
		}
	};

	this.deactivate = () => {
		familiesCta.off('.cursus');
	};

	return this;
}


export function factory(instance) {
	return DomainResult.call(sectionFactory(instance || {}));
}
